import { initI18n } from '@wix/wix-i18n-config';
import { loadStrings as loadSendersStrings } from '@wix/wix-emails-senders';

export function i18n(locale: string) {
  return initI18n({
    locale,
    useSuspense: true,
    asyncMessagesLoader: async (localeToLoad) => {
      try {
        const [emailTranslations, emailReactTranslations, sendersTranslations] =
          await Promise.all([
            import(`./assets/locale/messages_${localeToLoad}.json`),
            import(
              `@wix/shoutout-email-react/dist/cjs/assets/locale/messages_${localeToLoad}.json`
            ),
            loadSendersStrings(localeToLoad),
          ]);

        return {
          ...emailTranslations,
          ...emailReactTranslations,
          ...sendersTranslations,
        };
      } catch {
        const [emailTranslations, emailReactTranslations, sendersTranslations] =
          await Promise.all([
            import(`./assets/locale/messages_en.json`),
            import(
              `@wix/shoutout-email-react/dist/cjs/assets/locale/messages_en.json`
            ),
            loadSendersStrings('en'),
          ]);

        return {
          ...emailTranslations,
          ...emailReactTranslations,
          ...sendersTranslations,
        };
      }
    },
  });
}
